module.exports = __webpack_public_path__ + "static/media/imageedit.ef1ddb64.svg";